import { Route, Navigate } from 'react-router-dom'
import { SalesOrderLayout } from './pages/SalesOrderLayout'
import { OverviewPage } from './pages/OverviewPage'
import { AwaitingValidationPage } from './pages/AwaitingValidationPage'
import { DonePage } from './pages/DonePage'
import { InboxPage } from './pages/InboxPage'
import { EmailDetailPage } from './pages/EmailDetailPage'
import { CustomerOrderDetailPage } from './pages/CustomerOrderDetailPage'
import { CustomersPage } from './pages/CustomersPage'
import { CustomerSettingsPage } from './pages/CustomerSettingsPage'
import { SettingsPage } from './pages/SettingsPage'

/**
 * Sales order feature routes, mounted at /sales-order/:workflowId.
 *
 * The order confirmation product hangs off /workflow/:workflowId, where WorkflowPage picks the
 * layout by workflow type. Sales order has its own prefix instead, because the two products share
 * segment names — overview, inbox, settings, done — and mounting both under one path would leave
 * React Router matching whichever was declared first rather than the one the workflow calls for.
 */
export const salesOrderRoutes = (
  <Route element={<SalesOrderLayout />}>
    <Route index element={<Navigate to="overview/awaiting-validation" replace />} />
    <Route path="overview" element={<OverviewPage />}>
      <Route index element={<Navigate to="awaiting-validation" replace />} />
      <Route path="awaiting-validation" element={<AwaitingValidationPage />} />
      <Route path="done" element={<DonePage />} />
    </Route>
    <Route path="customer-order/:customerOrderId" element={<CustomerOrderDetailPage />} />
    <Route path="inbox" element={<InboxPage />} />
    <Route path="inbox/:emailId" element={<EmailDetailPage />} />
    <Route path="customers" element={<CustomersPage />} />
    <Route path="customers/:customerId/settings" element={<CustomerSettingsPage />} />
    <Route path="settings" element={<SettingsPage />} />
  </Route>
)
